import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Video } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { openVideoCall } from "../components/business/VideoCall";
import { fmtWhen } from "../components/business/bizUtils";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GuestMeet() {
  const { code } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/public/meet/${code}`).then((r) => setInfo(r.data)).catch((e) => setErr(e.response?.data?.detail || "رابط غير صالح")); }, [code]);
  const join = async () => {
    setBusy(true); setErr("");
    try { const r = await axios.post(`${API}/public/meet/${code}/join`, { name }); openVideoCall(r.data); }
    catch (e) { setErr(e.response?.data?.detail || "تعذّر الانضمام"); } finally { setBusy(false); }
  };
  return (
    <div dir="rtl" className="grid min-h-screen place-items-center bg-[#0E1A2B] p-4 font-body">
      <div className="w-full max-w-sm rounded-3xl bg-white p-7 shadow-2xl" data-testid="guest-meet">
        <div className="mb-4 grid h-12 w-12 place-items-center rounded-2xl bg-blue-600 text-white"><Video className="h-6 w-6" /></div>
        {!info && !err && <Loader2 className="h-5 w-5 animate-spin text-slate-400" />}
        {info && <>
          <p className="text-xs text-slate-500">{info.company}</p>
          <h1 className="mt-1 font-heading text-xl font-extrabold" data-testid="guest-meet-title">{info.title}</h1>
          <p className="mt-1 text-xs text-slate-500">{fmtWhen(info.start)}</p>
          <Input className="mt-5" value={name} onChange={(e) => setName(e.target.value)} placeholder="اكتب اسمك" data-testid="guest-meet-name" />
          <Button className="mt-3 w-full gap-2" disabled={busy || name.trim().length < 2} onClick={join} data-testid="guest-meet-join">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Video className="h-4 w-4" />} انضمام للاجتماع</Button>
          <p className="mt-3 text-center text-[11px] text-amber-700" data-testid="guest-meet-limit-note">تنبيه: الحد المجاني للاجتماعات المرئية 120 دقيقة يومياً</p>
        </>}
        {err && <p className="mt-3 text-sm text-rose-600" data-testid="guest-meet-error">{err}</p>}
      </div>
    </div>
  );
}
